import { render, staticRenderFns } from "./verify-payment.vue?vue&type=template&id=60df5f0a&scoped=true"
import script from "./verify-payment.vue?vue&type=script&lang=js"
export * from "./verify-payment.vue?vue&type=script&lang=js"
import style0 from "./verify-payment.vue?vue&type=style&index=0&id=60df5f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df5f0a",
  null
  
)

export default component.exports